import { css } from "@emotion/react";
import type { PropsWithChildren } from "react";

import Button from "../../../components/Button/Button";
import { getSpaceVariable } from "../../../components/space/utilities";
import { blockDefinitions } from "../../registry";
import type { BriefBlockType } from "../../schema";

type BlockOptionsPanelProps = PropsWithChildren<{
    onInsert: (type: BriefBlockType) => void;
    onRemove: () => void;
}>;

export default function BlockOptionsPanel(props: BlockOptionsPanelProps) {
    const { children, onInsert, onRemove } = props;
    return (
        <div
            css={css({
                display: "flex",
                flexDirection: "column",
                gap: getSpaceVariable(3),
                padding: getSpaceVariable(3),
            })}
        >
            {children}
            {Object.values(blockDefinitions).map((definition) => (
                <Button
                    key={definition.type}
                    label={`Insérer : ${definition.label}`}
                    action={() => onInsert(definition.type)}
                    feeling="minor"
                    role="minor"
                    size="small"
                />
            ))}
            <Button
                label="Supprimer"
                action={onRemove}
                feeling="danger"
                role="minor"
                size="small"
            />
        </div>
    );
}
